<template lang="pug">
.material
  Form(:model='question' label-position="right")
    .question-stem
      Button(icon="md-add",style='color:#3A76D2;border: 1px solid #3A76D2;margin-left: 12px;transform: translateY(-10px);',
        @click='showAIDialog()',v-if='enableAI') AI生成
      Modal(v-model="aiDialogVisible" title="AI生成" @on-ok="generateCase")
        Form(:model="aiForm" :label-width="80")
          FormItem(label="生成数量")
            InputNumber(v-model="aiForm.count" :min="1" :max="10" placeholder="请输入生成数量")
          FormItem(label="材料题子题数量")
            InputNumber(v-model="aiForm.material_sub_count" :min="1" :max="5" placeholder="请输入生成数量")
          FormItem(label='提示词',prop="stem")
            Input(v-model='aiForm.system' placeholder='请填写提示词'
              type="textarea" :rows="3")
      FormItem.title
        Input.input(v-model='question.stem'  placeholder='题目内容')
      iDelModel(:del-model='delModel',@upData="$emit('upData')",@downData="$emit('downData')")
    FormItem(v-show='isEditTips')
      Input(v-model='question.tips' placeholder='编辑提示信息')
    FormItem
      .questionsTitle 调研问题及回答设置
    .questions(v-for='(item,index) in question.metas')
      FormItem(:label='getQuestionTitle(index)' :label-width="80" style='width:75%;display:inline-block')
        Input(v-model.sync='item.question' placeholder='请输入问题内容')
      Button(type="text" v-if='index!==0' @click='delQuestion(index)' style='margin-left:10px') 删除
      FormItem(style='margin-left:80px')
        quill-editor.editor1(v-model.sync='item.answer' :options = "editorOption" )
      FormItem(style='margin-left:80px')
        Button.addExtraQuestion(type="primary" ghost @click='addExtraQuestion(index)') +  添加追加问题
      //- 追加问题
      .extraQuestion(v-for='(n,i) in question.metas[index].extraQuestionsList')
        FormItem(:label='getExtraQuestinTitle(i)',
          :label-width="80" style='margin-left:80px;width:75%;display:inline-block')
          Input(v-model.sync='n.question')
        Button(type="text" @click='delExtraQuestion(index,i)' style='margin-left:10px') 删除
        FormItem(style='margin-left:160px')
          quill-editor.editor2(v-model.sync='n.answer' :options = "editorOption")
      FormItem(style='margin-left:80px')
        Button.addQuestion(type="primary" ghost @click='addQuestion(index)') +  添加题目
    FormItem(label='分析问题' :label-width="80")
      Input(v-model='question.answer.parseQuestion' placeholder='请输入分析内容')
    FormItem(:label-width="80" label='参考答案' height).answertext
      //- quill-editor.editor2(v-model='question.answer.parseAnswer' :options = "editorOption" @blur="blueaa($event)")
      Input(v-model='question.answer.parseAnswer' type="textarea",
      :autosize="{minRows: 2,maxRows: 5}" :maxlength="500" :show-word-limit="true" placeholder="请输入参考答案")
    FormItem(label='答案解析' :label-width="80")
        Input(v-model='question.analysis' type="textarea",
      :autosize="{minRows: 2,maxRows: 5}")
    //- FormItem(label='评分关键词' :label-width="80")
    //-   iTag(:tag-data='question.scoringKeywords')
    FormItem(label='分值' :label-width="80")
      InputNumber(v-model='question.score' :max='100' :min='0'  style='width:100px')
    .question-edit
      isEditTips(:is-edit='isEditTips' :event='editTips')
</template>

<script>
/* eslint-disable */
import * as Quill from "quill"; // 引入编辑器
import iDelModel from "@/components/common/iDelModel";
import isEditTips from "@/components/common/iEditTips";
import iTag from "@/components/common/iTag.vue";
import Bus from "../../utils/bus";
const fonts = ["SimSun", "SimHei", "Microsoft-YaHei", "KaiTi", "FangSong", "Arial", "sans-serif"];
const Font = Quill.import("formats/font");
Font.whitelist = fonts; // 将字体加入到白名单
Quill.register(Font, true);
export default {
  components: {
    iDelModel,
    isEditTips,
    iTag,
  },
  props: ["data", "haId", "taskId", "enableAI"],
  data() {
    return {
      aiDialogVisible: false,
      aiForm: {},
      question: {
        stem: "",
        tips: "",
        metas: [
          {
            question: "",
            answer: "",
            extraQuestionsList: [], // 追加问题列表
          },
        ],
        answer: { parseQuestion: "", parseAnswer: "" },
        analysis: "", // 答案解析
        scoringKeywords: ["暂无"], // 评分关键词
        score: 0,
      },
      isEditTips: false,
      // 富文本编辑器配置
      editorOption: {
        placeholder: "请输入答案内容",
        modules: {
          toolbar: [
            [
              "bold",
              "italic",
              "underline",
              "strike",
              "image",
              "link",
              { indent: "-1" },
              { indent: "+1" },
              { align: "" },
              { align: "center" },
              { align: "right" },
              { color: [] },
              { background: [] },
              { font: fonts },
              { size: ["small", false, "large", "huge"] },
            ],
          ],
        },
      },
    };
  },
  methods: {
    showAIDialog() {
      this.aiDialogVisible = true;
      this.aiForm = { count: 1, system: "" , material_sub_count: 1};
    },
    generateCase() {
      if (this.taskId === "" || this.taskId === null || this.taskId === undefined) {
        this.$Message.error("无法生成！原因：需先保存当前场景！");
        return;
      }
      const data = {
        inputs: {
          opt_type: "MATERIALANALYSISPROBLEM",
          count: this.aiForm.count,
          material_sub_count: this.aiForm.material_sub_count,
          pyId: this.$store.state.Case.basic.id,
          tsId: this.taskId,
          haId: this.haId,
          score: 2,
          system: this.aiForm.system
        }
      };
      this.$http.generateCase(data).then((res) => {
        if (res.data.success) {
          this.$Message.success("保存成功");
          if (this.taskId !== this.haId) {
              Bus.$emit("refresh-task", this.taskId);
          } else {
              this.$emit("refresh-query");
          }
        }
      });
    },
    // 添加追加问题
    addExtraQuestion(index) {
      if (this.question.metas[index].extraQuestionsList.length < 3) {
        this.question.metas[index].extraQuestionsList.push({
          question: "",
          answer: "",
        });
      } else {
        this.$Message.error("每一题的追加问题最多添加3个");
      }
    },
    delExtraQuestion(index, i) {
      this.question.metas[index].extraQuestionsList.splice(i, 1);
      console.log("question", this.question);
    },
    // 添加问题
    addQuestion() {
      if (this.question.metas.length < 2) {
        this.question.metas.push({
          question: "",
          answer: "",
          extraQuestionsList: [],
        });
      } else {
        this.$Message.error("材料分析题的问题最多为2个");
      }
    },
    delQuestion(index) {
      this.question.metas.splice(index, 1);
    },
    editTips() {
      // 编辑提示
      this.isEditTips = !this.isEditTips;
    },
    delModel() {
      this.$emit("delModel");
    },
  },
  computed: {
    getExtraQuestinTitle() {
      return function (index) {
        return `#追问0${index + 1}`;
      };
    },
    getQuestionTitle() {
      return function (index) {
        return `#问题0${index + 1}`;
      };
    },
  },
  created() {
    this.$nextTick(() => {
      if (Object.keys(this.data).length !== 0) {
        this.question = this.data;
      }
      //   this.$emit("data1:data", this.question);
    });
  },
  watch: {
    question: {
      handler(val) {
        if (JSON.stringify(val) !== JSON.stringify(this.data)) {
          this.$emit("data1:data", val);
        }
      },
      deep: true,
      immediate: false // 初始时触发
    },
    data: {
      handler(val) {
        if (JSON.stringify(val) !== "{}") this.question = val; // 更新本地变量
      },
      immediate: true,
      deep: true
    }
  },
};
</script>

<style lang="stylus">
.material
  width 790px
  padding 24px 16px 24px 44px
  .question-stem
    position relative
    .ivu-form-item-content
      width 75%
  .answertext
    .ivu-input-word-count
      z-index 100
</style>
